// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","StrollerBoxWidget":"beg_a bhe_sl","StrollerBoxWidget__imageCounselling":"beg_b bhe_jz"};